import { render } from "./ParaAcademiquePage.vue?vue&type=template&id=63626037"
import script from "./ParaAcademiquePage.vue?vue&type=script&lang=js"
export * from "./ParaAcademiquePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__